import { useMemo, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';

const USER_OID_STORAGE_KEY = 'plng_user_oid';

/**
 * Извлекает Azure OID из MSAL-аккаунта с fallback на localStorage.
 * Сохраняет OID в localStorage при получении из MSAL,
 * чтобы ускорить повторную загрузку до готовности auth.
 */
export function useEffectiveOid(): string | null {
  const { accounts } = useMsal();

  const savedOid = useMemo((): string | null => {
    try {
      return localStorage.getItem(USER_OID_STORAGE_KEY);
    } catch {
      return null;
    }
  }, []);

  const msalOid = useMemo((): string | null => {
    try {
      if (!accounts || accounts.length === 0) return null;
      const account = accounts[0];
      const oid = (account.idTokenClaims as Record<string, unknown> | undefined)?.['oid'];
      return typeof oid === 'string' ? oid : null;
    } catch {
      return null;
    }
  }, [accounts]);

  useEffect(() => {
    if (msalOid) {
      try {
        localStorage.setItem(USER_OID_STORAGE_KEY, msalOid);
      } catch { /* quota exceeded */ }
    }
  }, [msalOid]);

  return msalOid ?? savedOid;
}
